const MISSING_PRICE_VALUES = new Set([null, undefined, ""]);

export const normalizeCatalogPrice = (value) => {
  if (MISSING_PRICE_VALUES.has(value)) return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;

  const normalized = String(value)
    .trim()
    .replace(/[\s\u00A0\u202F]/g, "")
    .replace(",", ".");

  if (!normalized || !/^-?(?:\d+(?:\.\d*)?|\.\d+)$/.test(normalized)) {
    return null;
  }

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
};

export const isValidCatalogPrice = (value) => {
  const normalized = normalizeCatalogPrice(value);
  return normalized !== null && normalized >= 0;
};

export const normalizeOptionalCatalogPrice = (value) => {
  if (MISSING_PRICE_VALUES.has(value)) return null;
  return normalizeCatalogPrice(value);
};
